import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { Button } from '../../shared/button/Button';
import styles from './ClientDatasets.module.scss';
import { getHiddenFieldsUpdated, getIsSaving, getClientDatasetsView, getUnsavedChangesModalOpen, ClientDatasetView, removeAllFieldSections, saveHiddenFieldsStarted, setClientDatasetView, toggleUnsavedChangesModal } from './store';
import { UnsavedChangesModal } from '../../shared/modal/UnsavedChangesModal';

interface ClientDatasetsButtonsProps {
    datasetId: number;
}

export const ClientDatasetsButtons: React.FC<ClientDatasetsButtonsProps> = ({ datasetId }) => {
    const dispatch = useAppDispatch();

    const isSaving = useAppSelector(getIsSaving);
    const hiddenFieldsUpdated = useAppSelector(getHiddenFieldsUpdated);
    const datasetView = useAppSelector(getClientDatasetsView);
    const unsavedChangesModalOpen = useAppSelector(getUnsavedChangesModalOpen);

    const collapseAllFieldsAndSections = () => dispatch(removeAllFieldSections());
    const toggleUnsavedChangesModalOpen = useCallback((isOpen: boolean) => dispatch(toggleUnsavedChangesModal(isOpen)), [dispatch]);
    const back = useCallback(() => dispatch(setClientDatasetView(ClientDatasetView.LIST, null)), [dispatch]);
    const onBackClick = useCallback(() => hiddenFieldsUpdated ? toggleUnsavedChangesModalOpen(true) : back(), [hiddenFieldsUpdated, toggleUnsavedChangesModalOpen, back]);
    const saveHiddenFields = useCallback(() => dispatch(saveHiddenFieldsStarted()), [dispatch]);
    const goToView = useCallback((view: ClientDatasetView) => dispatch(setClientDatasetView(view, datasetId)), [dispatch, datasetId]);

    const saveHiddenFieldsDisabled = useMemo(() => isSaving || !hiddenFieldsUpdated, [isSaving, hiddenFieldsUpdated]);

    const buttons = useMemo(() => (
        [ClientDatasetView.PREVIEW, ClientDatasetView.CONFIGURE].filter(view => view !== datasetView)
            .map(view => (<Button key={view} label={view} onClick={() => goToView(view)} />))
    ), [datasetView, goToView]);

    return (
        <div className={styles.buttonWrapper} style={{ width: '100%' }}>
            <div>
                <Button onClick={onBackClick} label='Back' />
            </div>
            <div className={styles.rightButtonsWrapper}>
                <Button onClick={collapseAllFieldsAndSections} label='Collapse All' />
                {buttons}
                <Button onClick={saveHiddenFields} label='Save' disabled={saveHiddenFieldsDisabled} />
            </div>
            <UnsavedChangesModal isOpen={unsavedChangesModalOpen} closeModal={() => toggleUnsavedChangesModalOpen(false)} confirm={back} />
        </div>
    );
};
